import { clsx } from 'clsx'
import { Space } from 'component/Space'
import { Typo } from 'component/Typo'
import { openSizesBanner } from 'feature/sizes/store'
import { useSizes } from 'feature/sizes/useSizes'
import { useLatestCallback } from 'hook/useLatestCallback'
import { i18n } from 'i18n'
import { Icon } from 'icon/Icon'
import { observer } from 'mobx-react-lite'
import { InferenceStore } from 'store/inference/InferenceStore'
import { opt } from 'store/opt'
import { renderSizes } from 'type/size'
import css from './ClothingSizes.module.scss'

type Props = {
  inference: InferenceStore
}

export const ClothingSizes = observer(({ inference }: Props) => {
  const sizes = useSizes(inference)
  const combo = inference.items.length > 1
  const square = opt.square && css.square

  const onOpen = useLatestCallback(() => {
    if (sizes) openSizesBanner(inference, sizes)
  })

  if (opt.irnby) return (
    <Space className={clsx(css.warn, square)} center>
      <Icon size={14} name="info" fill style={{ color: '#F96B0DE0' }} />
      <Typo line={14} size={12}>
        {i18n('CheckSizeGuideForAccurateSizing')}
      </Typo>
    </Space>
  )

  if (!sizes.length) return null

  return (
    <Space className={clsx(css.inline, square)}
      gap={6} wide center height={32} onClick={onOpen}>
      {renderSizes(sizes, combo)}
    </Space>
  )
})
